module.exports = __webpack_public_path__ + "img/A.f7f0dcc0.png";